var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServicePatrol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#58595B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1864",
    transform: "translate(2.744 1.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1863",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.4,2.2l-0.5,1.1L14.5,3l-2-3l-0.6,1.2C6.9-0.1,1.7,2.8,0.3,7.8c-0.8,2.7-0.3,5.7,1.4,8L2,15.6l0.2-0.1 l0.4-0.3c-2.7-3.8-1.8-9,2-11.7C6.5,2.1,9,1.6,11.4,2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1141"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.9,4.8L16.6,5l-0.1,0.1L16,5.4c2.7,3.8,1.8,9-2,11.7c-2,1.4-4.6,1.9-7,1.3l0.5-1.1L4,17.5l2,3l0.6-1.2 c5,1.4,10.2-1.5,11.6-6.5C19,10.1,18.5,7.1,16.9,4.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.3,16.2H9.2c-1.6-0.4-3-1.3-4-2.6C4,11.9,4.3,7.1,4.4,6.5V6h0.5c0,0,2.8,0.1,4.1-1.5L9.4,4l0.4,0.5 C11.1,6.1,13.9,6,13.9,6h0.5v0.5c0,0.5,0.4,5.3-0.8,7c-1.1,1.3-2.5,2.2-4.1,2.6L9.3,16.2z M5.2,7.1C5.1,8.7,5.1,11.9,5.9,13 c0.9,1,2,1.8,3.4,2.2c1.3-0.4,2.5-1.2,3.4-2.2c0.7-1,0.7-4.3,0.6-5.9c-0.9,0-2.8-0.3-4-1.4C8,6.8,6.1,7,5.2,7.1z M11.2,13.2 l-2-0.9l-2,0.9L7.6,11L6.1,9.5l2.1-0.4l1-1.9l1,1.9l2.1,0.4l-1.5,1.6L11.2,13.2z M9.3,11.1l0.7,0.3l-0.1-0.8l0.5-0.6H9.6 L9.3,9.3L8.9,10l-0.8,0.1l0.5,0.6l-0.1,0.8L9.3,11.1z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServicePatrol);
export default __webpack_public_path__ + "static/media/icon_service_patrol.05c3474f29368883ec545065ff80fe59.svg";
export { ForwardRef as ReactComponent };